import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "w90 pad15"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fw600 w30 fl pad20" }, "ダウンロード一覧", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "w100 ml20" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"w100\"><p class=\"fl fs12 fw600 ml15\" style=\"width:400px;\">ファイル名</p><p class=\"fl fs12 fw600\" style=\"width:120px;\">ファイルサイズ</p><p class=\"fl fs12 fw600\" style=\"width:180px;\">作成日時</p><p class=\"fl fs12 fw600\" style=\"width:150px;\">ステータス</p><div class=\"fl\" style=\"width:280px;\"> </div><div class=\"clear\"></div></div>", 1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { class: "w90 pad15" }
const _hoisted_9 = { class: "w100" }
const _hoisted_10 = { class: "fs13 fw600 w30 fl pad20" }
const _hoisted_11 = { class: "fs13 fw600 w60 fl" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadableFileCell = _resolveComponent("DownloadableFileCell")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_DownloadConditionsContent = _resolveComponent("DownloadConditionsContent")!
  const _component_InputFileNameModal = _resolveComponent("InputFileNameModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.Util.isPresent(_ctx.downloadableFiles))
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadableFiles, (file, fileindex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "w100",
                key: `${fileindex}${file.file_id}${file.original_filename}${file.status}`
              }, [
                _createVNode(_component_DownloadableFileCell, {
                  file: file,
                  onEditName: _ctx.editName
                }, null, 8, ["file", "onEditName"])
              ]))
            }), 128))
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createTextVNode(" 公開ページを指定 "),
          _createVNode(_component_IconHelp, {
            width: 18,
            tooltipText: `公開ページIDを入力すると、指定した公開ページの調整内容のみをダウンロードできます。`
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_MdTextfieldTag, {
            name: "公開ページIDを入力",
            fieldStyle: "min-width:250px;max-width:250px;",
            style: {"height":"56px","min-width":"250px"},
            class: "fs16 fl",
            value: _ctx.publicIds.join(','),
            onInputValue: _ctx.inputPublicIDs,
            required: ""
          }, null, 8, ["value", "onInputValue"]),
          _hoisted_12
        ]),
        _hoisted_13
      ]),
      _createVNode(_component_DownloadConditionsContent, { publicIds: _ctx.publicIds }, null, 8, ["publicIds"]),
      _hoisted_14
    ]),
    _hoisted_15,
    _createVNode(_component_InputFileNameModal, {
      file: _ctx.currentFile,
      onRenamed: _ctx.renamed
    }, null, 8, ["file", "onRenamed"])
  ]))
}